import React, { useState, useEffect } from "react";
import { useFetchWithToken } from "../../Components/FetchWithToken/FetchWithToken";
import { AuthContext } from "../../Constants/AuthProvider";
import { useLocation } from "react-router-dom";
import { apiUrl } from "../../Constants/Constants";
import BackButton from "../../Components/BackButton/BackButton.module";
import Loading from "../../Components/Loading/Loading.module";
import UserCard from "../../Components/UserCard/UserCard.module";
import { useModalManager } from "../../hooks/useModalManager.js";
import BuyTrafficModal from "../../Components/BuyTrafficModal/BuyTrafficModal.module.js";
import LoadingCircl from "../../Components/LoadingCircl/LoadingCircl.module.js";
import { toast } from "react-toastify";
const AccountSettings = () => {
  const { fetchWithToken, loading } = useFetchWithToken();
  const [loadingShow, setLoadingShow] = useState(false);
  const { onLogout } = React.useContext(AuthContext);
  const modalList = [
    "batchRenew",
    "autoRenew",
    "transaction",
    "pricing",
    "trafficBuy",
    "addCredit",
    "confirm",
    "payReserved",
  ];
  const { openModal, closeModal, isOpen, getPayload } =
    useModalManager(modalList);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accountid = queryParams.get("account");
  const [receivedData, setReceivedData] = useState({});
  const [firstTime, setFirstTime] = useState(true);
  const [circleLoading, setCircleLoading] = useState(true);

  useEffect(() => {
    if (firstTime) {
      setLoadingShow(loading);
    }
    if (loading == true) {
      setFirstTime(false);
    }
  }, [loading]);

  useEffect(() => {
    getInfo();
  }, []);
  const getInfo = () => {
    const former = new FormData();
    former.append("accountid", accountid);
    fetchWithToken(
      apiUrl + "user/fetch-profile",
      {
        method: "POST",
      },
      former
    )
      .then((data) => {
        setReceivedData(data.data);

        if (data.status === "401") {
          onLogout();
        }
        setCircleLoading(false);
      })
      .catch((error) => {
        toast.error("دریافت اطلاعات با خطا مواجه شد.");
        setCircleLoading(false); // مهمه که تو حالت خطا هم لودینگ قطع شه
      });
  };
  useEffect(() => {
    const id = setInterval(getInfo, 10000);
    return () => clearInterval(id);
  }, []);

  return (
    <div>
      <BackButton />
      <div className="cards-container">
        {receivedData?.profile && (
          <UserCard
            onMainPage={false}
            countryInfo={receivedData?.countryInfo}
            item={receivedData.profile}
            onBuyTraffic={() =>
              openModal("trafficBuy", receivedData.profile.id)
            }
            getInfo={getInfo}
            loadingShower={setLoadingShow}
          />
        )}
      </div>
      <BuyTrafficModal
        isOpen={isOpen("trafficBuy")}
        onClose={() => closeModal("trafficBuy")}
        account={getPayload("trafficBuy")}
        receivedData={receivedData}
        getInfo={getInfo}
        loadingShow={setLoadingShow}
        userWallet={receivedData.remainingWallet}
        singleMode={true}
      />

      {loadingShow &&
        (circleLoading ? (
          <div className="center-loading">
            <LoadingCircl />
          </div>
        ) : (
          <>
            <Loading />
          </>
        ))}
    </div>
  );
};

export default AccountSettings;
